import { makeStyles } from '@material-ui/core';
import { autoPopupServiceState, bookingState, cartState, cartVisibleState, categoriesState, isCartPrefilledState, packagesState, prefillCartState, servicesState, skipStepState, stepState } from 'pages/CustomerBookingCreate/state';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { toast } from 'react-hot-toast';
import { useHistory } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { getServiceDetails } from 'services/service.service';
import { toasterror } from 'util/toasterror';

const useMapPrefilledHook = ({ }) => {
  const [packages, setPackages] = useRecoilState(packagesState);
  const [services, setServices] = useRecoilState(servicesState);
  const [cart, setCart]= useRecoilState(cartState);
  const [booking, setBooking] = useRecoilState(bookingState);

  const [prefillName, setPrefillName] = useRecoilState(prefillCartState);
  const [mappedCategories, setMappedCategories] = useRecoilState(categoriesState)
  const [enableCart, setEnableCart] = useRecoilState(cartVisibleState);

  const [isCartPrefilled, setIsCartPrefilled] = useRecoilState(isCartPrefilledState);
  const [skipStep, setSkipStep] = useRecoilState(skipStepState);
  const [step, setStep] = useState(stepState);

  const [autoPopupService, setAutoPopupService] = useRecoilState(autoPopupServiceState);

  const [fillOption, setFillOption] = useState(null);
  const [loading, setLoading] = useState(false);

  const history = useHistory()

  const mapPrefillNameToBooking = useCallback(
    async () => {
      setLoading(true)
      if (!prefillName) {
        setLoading(false)
        return
      }
      // const prefillName = 'LAB_TESTS_WO_PRES'
      try {
        const findOption = mappedCategories?.reduce((acc, category) => {
          let containTargetBooking = false
          const targetService = category?.bookings?.find(c => {
            return c?.name === prefillName
          })
          if (targetService) {
            return targetService?.fillOptions
          }
          return acc
        }, null)

        setFillOption(findOption)
        if (!!findOption?.prefill?.rawService?.not_available || !!findOption?.disabled) {
        } else {
          setEnableCart(findOption?.canAddToCart)
          setPackages(findOption?.prefill?.packages)
          setServices(findOption?.prefill?.services)
          setBooking({ ...booking, serviceCategory: findOption?.prefill?.serviceCategory })

          setCart({
            services: findOption?.prefill?.services,
            packages: findOption?.prefill?.packages,
            booking: { ...booking, serviceCategory: findOption?.prefill?.serviceCategory }
          })
          setIsCartPrefilled(true)
        }
        setAutoPopupService(findOption?.prefill)
        setStep(findOption?.destinationStep)
        history.replace(findOption?.destinationStep, { internal: true })
        setPrefillName(null)
        setLoading(false)
        // const category = await getServiceDetails({ serviceId: typeId })
      } catch (error) {
        toasterror(error?.message?.en || error?.response?.data?.message?.en || error?.response?.data?.details)
        setPrefillName(null)
        setLoading(false)
      }

    },
    [prefillName, mappedCategories],
  );

  useEffect(
    () => {
      if (mappedCategories?.length > 0) {
        mapPrefillNameToBooking()
      }
    }, [mappedCategories]
  );

  return [setMappedCategories, loading, fillOption]
}

export { useMapPrefilledHook }